var map = {
	"./kgtech_security.postman_collection.json": 1729,
	"./scanbank_anomalies.postman_collection.json": 3419,
	"./scanbank_audit.postman_collection.json": 7417,
	"./scanbank_recommendations.postman_collection.json": 8904,
	"./scanbank_reports_exports.postman_collection.json": 3857,
	"./scanbank_workflows.postman_collection.json": 4394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6034;